module.exports = __webpack_public_path__ + "static/media/svg.a989a4a0.svg";